"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverCooperationAgreementStatus = void 0;
var DriverCooperationAgreementStatus;
(function (DriverCooperationAgreementStatus) {
    DriverCooperationAgreementStatus["HAS_ACTIVE"] = "HAS_ACTIVE";
    DriverCooperationAgreementStatus["HAS_NON_DECLINED"] = "HAS_NON_DECLINED";
    DriverCooperationAgreementStatus["HAS_NONE_OR_DECLINED"] = "HAS_NONE_OR_DECLINED";
})(DriverCooperationAgreementStatus || (exports.DriverCooperationAgreementStatus = DriverCooperationAgreementStatus = {}));
//# sourceMappingURL=DriverCooperationAgreementStatus.js.map